import script from "./Loading.vue?vue&type=script&setup=true&lang=js"
export * from "./Loading.vue?vue&type=script&setup=true&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=40bb2944&scoped=true&lang=css"

import exportComponent from "/Users/kobayashiyasutaka/Documents/Projects/murakihp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40bb2944"]])

export default __exports__